<template>
  <div>
    <!-- 手动添加要求 -->
    <el-dialog :title="$t('message.manuallyAddRequirements')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <el-input type="textarea" v-model="content" placeholder="如有其他需要抽查的内容，请在该处输入"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: '',
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    save() {
      if (this.content.trim() == '') return this.$message.error('内容不能为空')
      this.$parent.addToTask([{ desc: this.content }])
      this.dialogVisible = false
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  /deep/.el-textarea__inner {
    height: 200px !important;
    resize: none;
  }

}
</style>